import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { useTheme } from '@mui/material';

const SelectCantidadSoftland = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isDisabled
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: '0.0500',
            label: '5%'
        },
        {
            value: '0.1000',
            label: '10%'
        },
        {
            value: '0.1500',
            label: '15%'
        },
        {
            value: '0.2000',
            label: '20%'
        },
        {
            value: '0.2500',
            label: '25%'
        },
        {
            value: '0.3000',
            label: '30%'
        },
        {
            value: '0.3500',
            label: '35%'
        },
        {
            value: '0.4000',
            label: '40%'
        },
        {
            value: '0.4500',
            label: '45%'
        },
        {
            value: '0.5000',
            label: '50%'
        },
        {
            value: '0.5500',
            label: '55%'
        },
        {
            value: '0.6000',
            label: '60%'
        },
        {
            value: '0.6500',
            label: '65%'
        },
        {
            value: '0.7000',
            label: '70%'
        },
        {
            value: '0.7500',
            label: '75%'
        },
        {
            value: '0.8000',
            label: '80%'
        },
        {
            value: '0.8500',
            label: '85%'
        },
        {
            value: '0.9000',
            label: '90%'
        },
        {
            value: '0.9000',
            label: '95%'
        },
        {
            value: '1.0000',
            label: '100%'
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: state.isSelected 
                    ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                    : (isDarkMode ? '#3d4a62' : '#02378c'),
                color: state.isSelected 
                    ? (isDarkMode ? '#90caf9' : '#fff')
                    : (isDarkMode ? '#e0e0e0' : '#e0e0e0'),
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        })
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isDisabled={isDisabled}
        />
    );
};

SelectCantidadSoftland.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectCantidadSoftland;